module.exports = __webpack_public_path__ + "static/media/cnn.7ed8ebcc.png";